// @flow

import type {
  SearchItemsState,
  SearchListItem,
  SearchItem,
  SearchItemCategory,
  BabyListItemFoundStateType,
  Action,
} from "../types"
import {
  // uniqBy,
  includes,
  keys,
  some,
  map,
  flatten,
  groupBy,
  sortBy,
} from "lodash"
import {isBefore, isAfter, addDays} from "date-fns"

const initialState: SearchItemsState = {
  searchListItems: [],
  categories: [],
  suppliers: [],
  toggleds: [],
  foundRemarksToggleds: [],
}

const searchItems = (
  state: SearchItemsState = initialState,
  action: Action
): SearchItemsState => {
  switch (action.type) {
    case "SET_SEARCH_ITEMS":
      return {
        ...state,
        searchListItems: getUniqueSearchItems(action.searchItems),
        categories: extractCategories(action.searchItems),
        suppliers: action.searchItemSuppliers,
      }
    case "TOGGLE_SEARCH_LIST_ITEM":
      const {productId: actionProductId} = action
      return {
        ...state,
        toggleds: state.toggleds.includes(action.productId)
          ? [...state.toggleds].filter((t: number) => t !== actionProductId)
          : [...state.toggleds, action.productId],
      }
    case "CLOSE_ALL_SEARCH_ITEMS":
      return {
        ...state,
        toggleds: [],
      }
    case "SET_SEARCH_ITEM_FOUND_STATE_BULK":
      const {
        productId,
        babyListItemFoundIds,
        state: foundStateBulk,
        searchListItemIds,
      } = action
      const babyFoundCombos = searchListItemIds.map((s, idx) => {
        return {
          babyListItemId: s,
          babyListItemFoundId: babyListItemFoundIds[idx],
        }
      })
      return {
        ...state,
        searchListItems: state.searchListItems.map((item) => {
          if (item.productId !== productId) {
            return item
          }
          return {
            ...item,
            items: item.items.map((searchItem) => {
              const found = babyFoundCombos.find(
                (x) => x.babyListItemId == searchItem.uniqId
              )
              if (found) {
                return {
                  ...searchItem,
                  state: foundStateBulk,
                  babyListItemFoundId: found.babyListItemFoundId,
                }
              }
              return {...searchItem}
            }),
          }
        }),
      }
    case "SET_SEARCH_ITEM_FOUND_STATE":
      const {
        babyListItemFoundId,
        state: foundState,
        searchListItemId,
        remarks,
        isPhotographed,
      } = action
      /* console.log(action)
      state.searchListItems.forEach((item) => {
        console.log(item.productId, action.productId == item.productId)
        item.items.forEach((searchItem) => {
          console.log(
            searchItem.productId,
            action.productId == searchItem.productId
          )
        })
      }) */

      return {
        ...state,
        searchListItems: state.searchListItems.map((item) => {
          /* if (item.productId !== action.productId) {
            return item
          } */
          return {
            ...item,
            items: item.items.map((searchItem) => {
              /* console.log(searchItem.uniqId)
              console.log(searchListItemId) */
              if (searchItem.productId != action.productId) {
                return {...searchItem}
              }
              if (searchItem.uniqId == searchListItemId) {
                let newRemarks = searchItem.remarks
                if (remarks) {
                  newRemarks = remarks
                }
                return {
                  ...searchItem,
                  state: foundState,
                  babyListItemFoundId,
                  babyListItemFoundRemarks: newRemarks,
                  isPhotographed,
                }
              }
              /* console.log(searchItem.babyListItemFoundId)
              console.log(babyListItemFoundId) */
              if (searchItem.babyListItemFoundId == babyListItemFoundId) {
                return {...searchItem, babyListItemFoundRemarks: remarks}
              }
              return {...searchItem}
            }),
          }
        }),
      }
    case "SET_SEARCH_ITEM_PHOTOGRAPHED_LOCAL":
      return {
        ...state,
        searchListItems: state.searchListItems.map((sli) => ({
          ...sli,
          items: sli.items.map((searchItem) => {
            if (
              includes(
                action.babyListItemFoundIds,
                searchItem.babyListItemFoundId
              )
            ) {
              return {
                ...searchItem,
                isPhotographed: true,
              }
            }
            return searchItem
          }),
        })),
      }
    case "ACTIVATE_FOUND_REMARKS_ITEMS":
      return {
        ...state,
        foundRemarksToggleds: [
          ...state.foundRemarksToggleds,
          ...action.searchItemIds,
        ],
      }
    case "ACTIVATE_ALL_FOUND_REMARKS_ITEMS":
      return {
        ...state,
        foundRemarksToggleds: flatten(
          state.searchListItems.map((item) =>
            item.items.filter(
              (searchItem) =>
                searchItem.state == "todo" &&
                searchItem.babyListItemFoundRemarks !== ""
            )
          )
        ).map((i) => i.uniqId),
      }
    case "DEACTIVATE_ALL_FOUND_REMARKS_ITEMS":
      return {...state, foundRemarksToggleds: []}
    default:
      return state
  }
}

// selectors

// helpers
export const getUniqueSearchItems = (
  items: $ReadOnlyArray<SearchItem>
): $ReadOnlyArray<SearchListItem> => {
  // console.log("=> items", items)
  // console.log("Lijst Hadewych & Arnaud")

  // items.map((i) => {
  //   if (i.babyListId == 4543)
  //     console.log({
  //       name: i.name,
  //       // productId: i.productId,
  //       productLangId: i.productLangId,
  //       // productSetId: i.productSetId,
  //     })
  // })

  // console.log("Alle oefenbekers")

  // items.map((i) => {
  //   if (i.productSetId == 20 && i.productId == 115)
  //     console.log({
  //       name: i.name,
  //       productId: i.productId,
  //       productLangId: i.productLangId,
  //       productSetId: i.productSetId,
  //     })
  // })
  // 4543
  let processed = items.map((i) => {
    if (i.productLangId == 1) {
      return {...i, productNLBEId: i.productId}
    }
    if (i.productSetId != null && i.productNLBEId == null) {
      return {...i, productNLBEId: i.productId}
    }
    if (i.categoryId == null) {
      return {...i, productNLBEId: i.productId}
    }
    return i
  })
  processed = processed.filter((i) => i.productId != null)
  processed = groupBy(processed, "productNLBEId")
  processed = map(processed, (v, k) => {
    if (k == undefined || k == null) {
      v = groupBy(v, "productId")
    }
    return v
  })
  processed = processed.reduce((acc, items) => {
    const productId = items[0].productId
    const originalItem = items.find((i) => i.productId == productId)
    const newItem = {
      categoryId: originalItem.categoryId,
      items: items.map((subItem, idx) => ({...subItem, uniqId: idx})),
      productId: productId,
      nearestPickupDate: getNearestDate(items),
      // supplier: originalItem.supplier,
      supplierId: originalItem.supplierId,
      isCritical: some(items, (i) => i.isCritical),
      hasRemarks: some(items, (i) => i.remarks !== ""),
      amount: items.length,
    }
    return acc.concat([newItem])
  }, [])
  const sorted = processed.map((sli) => ({
    ...sli,
    items: sortBy(sli.items, (i) => i.baby.pickupDate).reverse(),
  }))
  return sorted
}

const getNearestDate = (items) => {
  if (items.length == 0) {
    return new Date(item.baby.pickupDate)
  }
  return sortBy(items, (i) => i.baby.pickupDate).reverse()[0].baby.pickupDate
}

/* const getNearestDate = (pickupDateString: string, nearestPickupDate: Date) => {
  const pickupDate = new Date(pickupDateString)
  return pickupDate < nearestPickupDate ? pickupDate : nearestPickupDate
} */

// Order is: OK -> ORDERED -> TODO -> MISSING -> OK
export const getNextFoundState = (state: ?BabyListItemFoundStateType) => {
  switch (state) {
    case "todo":
      return "missing"
    case "ok":
      return "ordered"
    case "ordered":
      return "todo"
    default:
      return "ok"
  }
}

export const extractCategories = (
  items: $ReadOnlyArray<SearchItem>
): $ReadOnlyArray<SearchItemCategory> => {
  const categories = items.reduce(
    (acc, {categoryId, category: {name, order}}) => {
      const categoryExists = acc.filter((c) => c.id == categoryId).length > 0
      if (!categoryExists) {
        acc = [...acc, {id: categoryId, order, name}]
      }

      return acc
    },
    []
  )
  return sortBy(categories, (c) => c.order)
}

export const getSearchListItemsByCategory = (
  items: $ReadOnlyArray<SearchListItem>,
  categoryId: number
): $ReadOnlyArray<SearchListItem> =>
  items.filter((sli) => sli.categoryId == categoryId)

export const getUrgentSearchListItems = (
  items: $ReadOnlyArray<SearchListItem>,
  endDate: Date
): $ReadOnlyArray<SearchListItem> => {
  const sorted = sortBy(
    items,
    (searchListItem) => searchListItem.nearestPickupDate
  )
  return sorted
    .map((searchListItem) => ({
      ...searchListItem,
      items: searchListItem.items.filter(
        (item) =>
          isAfter(item.baby.pickupDate, new Date()) &&
          isBefore(item.baby.pickupDate, addDays(endDate, 1))
      ),
    }))
    .filter((searchListItem) => searchListItem.items.length > 0)
    .map((searchListItem) => ({
      ...searchListItem,
      amount: searchListItem.items.length,
    }))
}

export const getCriticalSearchListItems = (
  items: $ReadOnlyArray<SearchListItem>
): $ReadOnlyArray<SearchListItem> => items.filter((item) => item.isCritical)

export const isSearchListItemComplete = (item: SearchListItem): boolean =>
  item.items.filter((item) => item.state == "ok").length == item.items.length

export const hasFoundRemarks = (item: SearchListItem): boolean =>
  item.items.filter(
    (item) =>
      item.babyListItemFoundRemarks !== "" &&
      item.babyListItemFoundRemarks !== null
  ).length > 0

// Similar to getNextFoundState, but decides what the next state is in bulk
// if all items have the same state, we just progress one step
// if at least on differs, we set them to the first state, which is 'OK'
export const getNextFoundStateBulk = (
  item: SearchListItem
): BabyListItemFoundStateType => {
  const groupedTypes = groupBy(item.items, "state")
  const types = keys(groupedTypes)
  if (types.length == 1) {
    // all the same type
    return getNextFoundState(types[0])
  }
  // not all the same, return 'ok'
  return "ok"
}

// returns true if all items have the state 'ok'
export const isPhotographedReady = (item: SearchListItem): boolean =>
  item.items.filter((i) => i.state != null).length == item.items.length

export const getItemForStandalone = (
  items: $ReadOnlyArray<SearchListItem>
): ?SearchItem => {
  if (items.length > 0 && items[0].items.length > 0) {
    return items[0].items[0]
  }
  return null
}

/* export const getSuppliers = (
  items: $ReadOnlyArray<SearchListItem>
): $ReadonlyArray<any> =>
  uniqBy(
    items.reduce(
      (suppliers, item) =>
        item.supplier ? [...suppliers, item.supplier] : suppliers,
      []
    ),
    "id"
  ) */

export default searchItems
